import React from "react";
import { Link } from "react-router-dom";
import withBreadcrumbs from "react-router-breadcrumbs-hoc";

import withPageInfo from "../hocs/withPageInfo";
import withVehicle from "../hocs/withVehicle";
import withTopicCluster from "../hocs/withTopicCluster";

import SmallText from "../styleguide/SmallText";
import { ArrowRight } from "./Icons";

const BreadcrumbItem = ({ page, currentPage }) => (
    <div
        style={{
            display: "inline-flex",
            alignItems: "center",
            marginRight: 8,
            color: currentPage ? "#e40045" : "#303a44",
        }}
    >
        <ArrowRight size={12} />
        <Link to={page.props.match.url} style={{ marginLeft: 2, color: "inherit", textDecoration: "none" }}>
            <SmallText style={{ color: "inherit" }}>{page}</SmallText>
        </Link>
    </div>
);

const Breadcrumbs = ({ breadcrumbs, onlyShowHome }) => (
    <nav aria-label="breadcrumb" style={{ display: "inline-flex", flex: 1 }}>
        {onlyShowHome ? (
            <BreadcrumbItem key="home" page={breadcrumbs[0]} currentPage={false} />
        ) : (
            breadcrumbs.map((breadcrumb, index) => {
                return <BreadcrumbItem key={index} page={breadcrumb} currentPage={index === breadcrumbs.length - 1} />;
            })
        )}
    </nav>
);

const PageTitle = withPageInfo((props) => <span style={{ whiteSpace: "nowrap" }}>{props.pageInfo.title}</span>);
const PageParentTitle = withPageInfo((props) => (
    <span style={{ whiteSpace: "nowrap" }}>{props.pageInfo.parentTitle}</span>
));

const VehicleTitle = withVehicle(({ vehicle }) => <span style={{ whiteSpace: "nowrap" }}>{vehicle.title}</span>);

const TopicClusterTitle = withTopicCluster(({ topicCluster }) => (
    <span style={{ whiteSpace: "nowrap" }}>{topicCluster.title}</span>
));

const routes = [
    { path: "/", breadcrumb: "Home" },
    { path: "/news", breadcrumb: "News" },
    { path: "/buscast", breadcrumb: "BusCasts" },
    { path: "/buscast/:id", breadcrumb: PageTitle },

    { path: "/e-mobility", breadcrumb: "E-Mobility Knowledge" },
    { path: "/e-mobility/:topicSlug", breadcrumb: PageParentTitle },
    { path: "/e-mobility/:topicSlug/:slug", breadcrumb: PageTitle },

    { path: "/transport-solutions", breadcrumb: "Transport Solutions" },
    { path: "/transport-solutions/:topicSlug", breadcrumb: PageParentTitle },
    { path: "/transport-solutions/:topicSlug/:slug", breadcrumb: PageTitle },

    { path: "/vehicle/:vehicleSlug", breadcrumb: VehicleTitle },
    {
        path: "/vehicle/:vehicleSlug/customer-benefit/:slug",
        breadcrumb: PageTitle,
    },
    { path: "/vehicle/:vehicleSlug/topic/:slug", breadcrumb: PageTitle },
    { path: "/vehicle/:vehicleSlug/component/:slug", breadcrumb: PageTitle },

    { path: "/topic-cluster/:topicClusterSlug", breadcrumb: TopicClusterTitle },
    { path: "/topic-cluster/:topicClusterSlug/:slug", breadcrumb: PageTitle },
];

export default withBreadcrumbs(routes, { disableDefaults: true })(Breadcrumbs);



// WEBPACK FOOTER //
// ./src/components/Breadcrumbs.js